import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './ArticleDetailScreen.css';
import Breadcrumb from '../../components/Breadcrumb';
import ArticleHeader from './components/ArticleHeader';
import FeaturedImage from './components/FeaturedImage';
import VideoEmbed from '../../components/VideoEmbed';
import SocialShareButtons from './components/SocialShareButtons';
import RelatedArticles from './components/RelatedArticles';
import { useArticleDetail } from './hooks/useArticleData';
import { LoadingState, ErrorState } from '../../components';

function ArticleDetailScreen() {
  const { id } = useParams();
  const { article, relatedArticles, author, loading, error } = useArticleDetail(id);

  if (loading) {
    return (
      <div className="article-detail-screen">
        <div className="article-detail-container">
          <LoadingState message="Caricamento articolo..." />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="article-detail-screen">
        <div className="article-detail-container">
          <Breadcrumb to="/articles" label="Torna agli articoli" />
          <ErrorState 
            message={error}
            onRetry={() => window.location.reload()}
            retryText="Ricarica"
          />
        </div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="article-detail-screen">
        <div className="article-detail-container">
          <Breadcrumb to="/articles" label="Torna agli articoli" />
          <div className="not-found-container">
            <i className="fa-regular fa-file"></i>
            <h2>Articolo non trovato</h2>
            <p>L'articolo che stai cercando non esiste o è stato rimosso.</p>
            <a href="/articles" className="back-button">Torna agli articoli</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="article-detail-screen">
      <div className="article-detail-container">
        <Breadcrumb to="/articles" label="Torna agli articoli" />

        <article className="article-detail">
          <ArticleHeader
            title={article.title}
            date={article.date}
            author={author}
          />

          <FeaturedImage 
            src={article.photo_link}
            alt={article.title}
          />

          <VideoEmbed 
            src={article.video_link}
            title={article.title}
          />

          <div className="article-body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.text) }} />

          <div className="article-footer">
            <SocialShareButtons 
              title={article.title}
              url={window.location.href}
            />
          </div>
        </article>

        <RelatedArticles articles={relatedArticles} />
      </div>
    </div>
  );
}

export default ArticleDetailScreen;
